import * as z from 'zod';

import { BuildingAndSystemsSchema } from './categories/building-and-systems';
import { ControlsSchema } from './categories/controls';
import { DomesticColdWaterSchema } from './categories/domestic-cold-water';
import { DomesticHotWaterSchema } from './categories/domestic-hot-water';
import { EnvelopeSchema } from './categories/envelope';
import { GeneralSchema } from './categories/general';
import { LightingSchema } from './categories/lighting';
import { MainBreakerSchema } from './categories/main-breaker';
import { SpaceCoolingSchema } from './categories/space-cooling';
import { SpaceHeatingSchema } from './categories/space-heating';
import { VentilationSchema } from './categories/ventilation';
import { OtherSchema } from './categories/other';

export const AuditBackgroundFormSchema = z.object({
  type: z.literal('background'),

  general: GeneralSchema,
  envelope: EnvelopeSchema,
  mainBreaker: MainBreakerSchema,
  controls: ControlsSchema,
  spaceHeating: SpaceHeatingSchema,
  spaceCooling: SpaceCoolingSchema,
  ventilation: VentilationSchema,
  domesticColdWater: DomesticColdWaterSchema,
  domesticHotWater: DomesticHotWaterSchema,
  lighting: LightingSchema,
  buildingAndSystems: BuildingAndSystemsSchema,
  other: OtherSchema,
});

export type AuditBackgroundForm = z.infer<typeof AuditBackgroundFormSchema>;
